<template>
  <div class="col-12 col-lg-8 offset-lg-2 mb-4">
    <div class="card flex-grow-1">
      <div class="card-header text-center">
        <h4>{{ foodGroupName }}</h4>
      </div>
      <div class="card-body text-center">
        <p v-html="foodAmtValuation()" />
        <p
          v-show="answers.servings > 0"
          v-html="foodQualityValuation()"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: String,
    answers: Object,
    foodGroupDesc: Object,
  },
  computed: {
    foodGroupName(){
      return this.foodGroupDesc.name;
    },
    foodGroupData(){
      if (this.answers.serving_type == 'green')        return { text:'Green',            class:'text-green'};
      if (this.answers.serving_type == 'green-yellow') return { text:'Green and Yellow', class:'text-green-light'};
      if (this.answers.serving_type == 'yellow')       return { text:'Yellow',           class:'text-yellow-dark'};
      if (this.answers.serving_type == 'yellow-red')   return { text:'Yellow and Red',   class:'text-red'};
      if (this.answers.serving_type == 'red')          return { text:'Red',              class:'text-red'};
    },
  },
  methods:{
    foodAmtValuation(){
      if (this.answers.servings == 0) return `You consume <b>no</b> ${this.foodGroupName}.`;
      if (this.answers.servings == 1) return `You consume a <b>small</b> amount of ${this.foodGroupName}.`;
      if (this.answers.servings == 2) return `You consume a <b>decent</b> amount of ${this.foodGroupName}.`;
      if (this.answers.servings == 3) return `You consume a <b>good</b> amount of ${this.foodGroupName}.`;
      if (this.answers.servings >= 4) return `You consume a <b>large</b> amount of ${this.foodGroupName}.`;
    },
    foodQualityValuation(){
      if (this.foodGroupName == 'Dairy' || this.foodGroupName == 'Meat and/or other Protein'){
        return `The ${this.foodGroupName} you eat is mainly <span class="${this.foodGroupData.class}">${this.foodGroupData.text}</span>.`
      } else {
        return `The ${this.foodGroupName} you eat are mainly <span class="${this.foodGroupData.class}">${this.foodGroupData.text}</span>.`
      }
    }
  },
}
</script>
